/**
 * @module Components.Subscription
 *
 */
import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useActions } from "app/utils/hooks";
import { Token } from "app/utils/stripe";
import { RootState } from "app/reducers";
import { fetchSelf } from "app/actions/user";
import { updatePaymentInfo } from "app/actions/payment-info";
import StripeForm from "app/components/StripeForm";
import { ErrorMessage } from "app/components/helpers";
import styles from "./styles.module.scss";
import { Redirect, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isBilledByOrganization } from "app/utils/subscription";

function BillingInfoEdit() {
  const { t } = useTranslation();
  const history = useHistory();
  const paymentInfo = useSelector((state: RootState) => state.paymentInfo, shallowEqual);
  const self = useSelector((state: RootState) => state.user.self, shallowEqual);
  const actions = useActions({ fetchSelf, updatePaymentInfo });

  useEffect(() => (actions.fetchSelf(), undefined), [actions.fetchSelf]);

  // Nothing here belongs to a coach on a licensed seat billed outside his own
  // account: he holds no customer of his own, so the API answers this form's
  // save with a 404. Send him to the billing page that tells him who does pay.
  // Held until self is known so the card form never flashes on the way.
  if (!self) {
    return null;
  }

  if (isBilledByOrganization(self)) {
    return <Redirect to="/account/billing_info" />;
  }

  const _updatePaymentInfo = (token: Token): void => {
    actions.updatePaymentInfo(token.id).then(() => leaveEdit());
  };

  const leaveEdit = () => {
    // route("/account/billing_info");
    history.goBack();
  };

  return (
    <div className={styles.billingInfoEdit}>
      <StripeForm
        disabled={paymentInfo.pending}
        submitTitle={t("Save Changes")}
        onToken={_updatePaymentInfo}
        onCancel={leaveEdit}
      />

      <ErrorMessage message={paymentInfo.error} />
    </div>
  );
}

export default BillingInfoEdit;
